const DOCTYPES = {
  ACCOUNT: 'Account',
  ACTIVITY_TYPE: 'Activity Type',
  ADDRESS: 'Address',
  AUTO_REPEAT: 'Auto Repeat',
  BANK: 'Bank',
  COMMUNICATION: 'Communication',
  COMPANY: 'Company',
  CONNECTED_APP: 'Connected App',
  CONTACT: 'Contact',
  CONTACT_EMAIL: 'Contact Email',
  CONTACT_PHONE: 'Contact Phone',
  COST_CENTER: 'Cost Center',
  COUNTRY: 'Country',
  CURRENCY: 'Currency',
  CUSTOMER: 'Customer',
  CUSTOMER_GROUP: 'Customer Group',
  DATA_IMPORT: 'Data Import',
  DATEV_SETTINGS: 'DATEV Settings',
  DATEV_UNTERNEHMEN_ONLINE_SETTINGS: 'DATEV Unternehmen Online Settings',
  DELIVERY_NOTE: 'Delivery Note',
  DOCUMENT_NAMING_SETTINGS: 'Document Naming Settings',
  DUNNING: 'Dunning',
  DUNNING_PLAN: 'Dunning Plan',
  DUNNING_TYPE: 'Dunning Type',
  DYNAMIC_LINK: 'Dynamic Link',
  E_INVOICE_IMPORT: 'E Invoice Import',
  EMAIL_ACCOUNT: 'Email Account',
  EMAIL_DOMAIN: 'Email Domain',
  EMAIL_GROUP: 'Email Group',
  EMAIL_GROUP_MEMBER: 'Email Group Member',
  EMAIL_TEMPLATE: 'Email Template',
  EMPLOYEE: 'Employee',
  EVENT: 'Event',
  FILE: 'File',
  GOOGLE_CALENDAR: 'Google Calendar',
  GOOGLE_SETTINGS: 'Google Settings',
  INDUSTRY_TYPE: 'Industry Type',
  ITEM: 'Item',
  ITEM_GROUP: 'Item Group',
  ITEM_PRICE: 'Item Price',
  LETTER_HEAD: 'Letter Head',
  MARKETING_CAMPAIGN: 'Marketing Campaign',
  NEWSLETTER: 'Newsletter',
  NOTIFICATION: 'Notification',
  NOTIFICATION_LOG: 'Notification Log',
  OPPORTUNITY: 'Opportunity',
  PAYMENT_ENTRY: 'Payment Entry',
  PAYMENT_TERM: 'Payment Term',
  PAYMENT_TERMS_TEMPLATE: 'Payment Terms Template',
  PRICE_LIST: 'Price List',
  PRICING_RULE: 'Pricing Rule',
  PRINT_FORMAT: 'Print Format',
  PROJECT: 'Project',
  PURCHASE_INVOICE: 'Purchase Invoice',
  PURCHASE_ORDER: 'Purchase Order',
  PURCHASE_RECEIPT: 'Purchase Receipt',
  QUOTATION: 'Quotation',
  QUOTATION_LOST_REASON: 'Quotation Lost Reason',
  REPORT: 'Report',
  REQUEST_FOR_QUOTATION: 'Request for Quotation',
  SALES_INVOICE: 'Sales Invoice',
  SALES_ORDER: 'Sales Order',
  SALES_PARTNER: 'Sales Partner',
  SALUTATION: 'Salutation',
  SERIAL_NO: 'Serial No',
  SLACK_WEBHOOK_URL: 'Slack Webhook URL',
  STOCK_ENTRY: 'Stock Entry',
  SUPPLIER: 'Supplier',
  SUPPLIER_GROUP: 'Supplier Group',
  SUPPLIER_QUOTATION: 'Supplier Quotation',
  SYSTEM_SETTINGS: 'System Settings',
  TAG: 'Tag',
  TAG_LINK: 'Tag Link',
  TASK: 'Task',
  TERMS_AND_CONDITIONS: 'Terms and Conditions',
  TIMESHEET: 'Timesheet',
  TODO: 'ToDo',
  TOKEN_CACHE: 'Token Cache',
  TW_ACTIVITY_DOCUMENTATION: 'TW Activity Documentation',
  TW_BUYING_CENTER_ROLE: 'TW Buying Center Role',
  TW_EMAIL_CONFIG: 'TW Email Config',
  TW_FAVORITE: 'TW Favorite',
  TW_INVESTOR_TYPE: 'TW Investor Type',
  TW_MANAGEMENT_REPORT_ROW: 'TW Management Report Row',
  TW_MANAGEMENT_REPORT_SUMMARY_ROW: 'TW Management Report Summary Row',
  TW_ORGANIZATION: 'TW Organization',
  TW_OTHER: 'TW Other',
  TW_OTHER_TYPE: 'TW Other Type',
  TW_PARTNER: 'TW Partner',
  TW_PERSON: 'TW Person',
  TW_PHONE_TYPE: 'TW Phone Type',
  TW_RATING: 'TW Rating',
  TW_ROLE: 'TW Role',
  TW_VAT_RETURN_ROW: 'TW VAT Return Row',
  TW_WEBLINK_TYPE: 'TW Weblink Type',
  TW_WEBLINKS: 'TW Weblinks',
  UOM: 'UOM',
  USER: 'User',
  WAREHOUSE: 'Warehouse',
  WEBHOOK: 'Webhook',
} as const

const isDoctype = (check_val: string): check_val is DocType => {
  return Object.values(DOCTYPES).some((doctype) => doctype === check_val)
}

export { DOCTYPES, isDoctype }

export type DocType = (typeof DOCTYPES)[keyof typeof DOCTYPES]
